module.exports = __webpack_public_path__ + "static/media/yellowbig.04dfdf9c.svg";